import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Default = all features enabled until the API responds (avoid flash of "disabled" UI)
const DEFAULT_FLAGS = {
  gite_salle_enabled: true,
};

let cached = null;
let cachePromise = null;

export function useFeatureFlags() {
  const [flags, setFlags] = useState(cached || DEFAULT_FLAGS);

  useEffect(() => {
    if (cached) {
      setFlags(cached);
      return;
    }
    if (!cachePromise) {
      cachePromise = axios
        .get(`${BACKEND_URL}/api/public/feature-flags`)
        .then(r => {
          cached = { ...DEFAULT_FLAGS, ...(r.data || {}) };
          return cached;
        })
        .catch(() => DEFAULT_FLAGS);
    }
    cachePromise.then(data => setFlags(data));
  }, []);

  return flags;
}
